<template>
    <div class="grid grid-cols-3 bottom-nav px-4">
        <MenuBarItem label="สิทธิพิเศษ" :to="privilegePage" @click="clickMenu('privilege')">
            <template #activeIcon>
                <img src="@/assets/icon/menubar/privillage.active.svg" alt=""/>
            </template>
            <template #icon>
                <img src="@/assets/icon/menubar/privillage.svg" alt=""/>
            </template>
        </MenuBarItem>
        <MenuBarItem label="ประวัติรับสิทธิ์" to="/history" @click="clickMenu('history')">
            <template #activeIcon>
                <img src="@/assets/icon/menubar/history.active.svg" alt=""/>
            </template>
            <template #icon>
                <img src="@/assets/icon/menubar/history.svg" alt=""/>
            </template>
        </MenuBarItem>
        <MenuBarItem label="ช่วยเหลือ" to="/help" @click="clickMenu('help')">
            <template #activeIcon>
                <img src="@/assets/icon/menubar/help.active.svg" alt=""/>
            </template>
            <template #icon>
                <img src="@/assets/icon/menubar/help.svg" alt=""/>
            </template>
        </MenuBarItem>
    </div>
</template>

<script>
import { defineComponent, ref } from 'vue';
import { useRoute } from 'vue-router';
import MenuBarItem from './MenuBarItem.vue';
import { useTracking } from "@/feature/TrackingFeature"

export default defineComponent({
    setup: function () {
        const route = useRoute()
        const privilegePage = ref(null) ;
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()

        const getPathName = function() {
            let routeName = route.fullPath
            if (routeName.indexOf('/privilege') >= 0) {
                return privilegePage.value = routeName
            } else {
                return privilegePage.value = '/privilege';
            }
        }

        const clickMenu = (menu) => {
            if (menu == 'history') {
                tracking.event("privilege_page_list", "click_history_menu", "", "");
            } else if (menu == 'help') {
                tracking.event("privilege_page_list", "click_help_menu", "", "");
            } else {
                tracking.event("privilege_page_list", "click_privilege_menu", "", "");
            }
        }

        getPathName()

        return { route, privilegePage, clickMenu }
    },
    components: { MenuBarItem }
})
</script>

<style lang="scss" scoped>
.bottom-nav {
    box-shadow: 0 -3px 15px 0 rgba(0, 0, 0, 0.1);
    @apply fixed left-0 right-0 bottom-0 w-full bg-white max-w-lg mx-auto;
}
</style>
